import React, { useState, useEffect } from 'react';

const collection = [
    {
        header: '404. Lost in the Galaxy',
        image: '/website/dog_space.webp',
        h2: 'The page you are looking for is not found'
    },
    {
        header: '404. Oops! It seems the page is not drawn yet',
        image: '/website/404_sm.webp',
        h2: 'Our team is working on it. Please check back later.'
    }
];

function App() {
    const [selected, setSelected] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * collection.length);
        const item = collection[randomIndex];
        setSelected(item);

        const img = new Image();
        img.src = item.image;
        img.onload = () => setImageLoaded(true);
    }, []);

    if (!selected) return null;

    return (
        <div className="page-container">
            <div className="page-layout">
                <div className="d-flex flex-column align-items-center">
                    <h1 className='notification text-center'><br/><br/>{selected.header}</h1>
                    <img
                        src={selected.image}
                        alt="404"
                        className="img-responsive"
                        style={{
                            opacity: imageLoaded ? 1 : 0,
                            transform: imageLoaded ? 'translateY(0)' : 'translateY(20px)',
                            transition: 'opacity 0.6s ease, transform 0.6s ease',
                        }}
                    />
                    <h2 className='text-center'>{selected.h2}</h2>
                </div>
            </div>
        </div>
    );
}

export default App;
